import React from 'react'
import styled from 'styled-components'

import ResponsiveImage from 'components/Common/ResponsiveImage'
import GoogleCardImage from 'tripPlanner/components/ItemCard/Common/GoogleCardImage'
import { ItemMetadata } from 'tripPlanner/models'
import ItemImagePlaceholder from 'tripPlanner/Tripkit/Common/ItemImagePlaceholder'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from 'tripPlanner/utils'

const BaseContainer = styled.div`
  position: relative;
  align-self: stretch;
  aspect-ratio: 1 / 1;
`

const Image = styled.img`
  position: absolute;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
`

interface Props {
  item: TripItem
  name: string
  /** URL of external image */
  imgSrc?: string
  /** ID of image from svc-image */
  imgId?: string
  placeId?: string
}

function ItemCardImage({ item, name, imgId, imgSrc, placeId }: Props) {
  const Icon = ItemMetadata[item.type].icon
  const place = getItemPlace(item, 'start')

  let imageElement: React.ReactNode
  const placeHolderImage = (
    <ItemImagePlaceholder icon={<Icon size={30} colour="neutral-four" />} />
  )

  if (imgId) {
    imageElement = (
      <ResponsiveImage
        fit="center"
        id={imgId}
        mobileAspectRatio="1"
        mobileWidth="64px"
        tabletAspectRatio="1"
        tabletWidth="104px"
      />
    )
  } else if (placeId) {
    imageElement = (
      <GoogleCardImage
        placeId={placeId}
        title={name}
        placeholder={placeHolderImage}
        tripId={item.tripId}
        tripItemId={item.id}
      />
    )
  } else if (imgSrc) {
    imageElement = <Image src={imgSrc} />
  } else if (place?.photoUrl) {
    imageElement = <Image src={place.photoUrl} />
  } else {
    imageElement = placeHolderImage
  }

  return <BaseContainer>{imageElement}</BaseContainer>
}

export default ItemCardImage
